<app-loading-spinner *ngIf="showSpinner"></app-loading-spinner>
<div *ngIf="!showSpinner">
  <app-menu></app-menu>

  <mat-card class="avaliacao-card">
    <mat-card-title clas="avaliacao-titulo">
      <div style="text-align: center;">
        Avaliação das equipes
      </div>
    </mat-card-title>
    <mat-card-content class="avaliacao-container">

      <div style="text-align: center;">
        <p>Cada equipe possui uma ou mais avaliações!</p>
        <p>Tenha boas avaliações!</p>
      </div>

      <mat-accordion>
        <mat-expansion-panel *ngFor="let equipe of getAvaliacoes()">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <b>Equipe: {{ equipe.nomeEquipe }}</b>
            </mat-panel-title>

            <mat-panel-description>
              Abra para mais detalhes
            </mat-panel-description>
          </mat-expansion-panel-header>

          <mat-accordion>
            <mat-expansion-panel *ngFor="let avaliacao of equipe.avaliacoes">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ avaliacao.titulo }}
                </mat-panel-title>

                <mat-panel-description>
                  Pontuação: {{ avaliacao.pontuacao }}
                </mat-panel-description>
              </mat-expansion-panel-header>

              <div style="text-align: center; margin: 8px;">
                Pontuação:
                <mat-slider
                  [(ngModel)]="avaliacao.pontuacao"
                  [max]="10"
                  [thumbLabel]="true"></mat-slider>
              </div>

              <p>Conteúdo entregue:</p>
              <div [innerHTML]="avaliacao.entrega"></div>

            </mat-expansion-panel>
          </mat-accordion>

        </mat-expansion-panel>
      </mat-accordion>

      <div style="text-align: center; margin: 8px;">
        <button mat-raised-button (click)="salvar()">Salvar Avaliações</button>
      </div>

    </mat-card-content>
  </mat-card>
</div>
